import styled, { css } from 'styled-components';

export const asAnchor = css`
	cursor: pointer;
	color: ${props => props.theme.colors.primary};
	transition: color 200ms ease;

	&:hover {
		color: ${props => props.theme.colors.primaryDark};
	}
`;

export const A = styled.a`
	${asAnchor}
`;
